export default {
	name: 'Membership.Payments.Update',
	path: 'membership/payments/update',
	meta: {
		auth: true
	}
}